/* DT Sticky Add To Cart - Chócala! Eco-Design® */
(function(){
  const sticky = document.querySelector('[data-dt-sticky-atc]');
  if(!sticky) return;

  const formId = sticky.getAttribute('data-form-id');
  const productForm = formId ? document.getElementById(formId) : null;
  if(!productForm) return;

  const stickyBtn = sticky.querySelector('[data-dt-sticky-btn]');
  const stickyPrice = sticky.querySelector('[data-dt-sticky-price]');
  const stickyCompare = sticky.querySelector('[data-dt-sticky-compare]');
  const stickySaleLabel = sticky.querySelector('[data-dt-sticky-sale-label]');
  const stickyDiscount = sticky.querySelector('[data-dt-sticky-discount]');
  const stickyDiscountPct = sticky.querySelector('[data-dt-sticky-discount-pct]');
  const stickyImg = sticky.querySelector('[data-dt-sticky-image]');
  const featuredImgUrl = sticky.getAttribute('data-featured-img') || '';

  const submitBtn = productForm.querySelector('button[type="submit"], input[type="submit"]');
  if(!stickyBtn || !submitBtn) return;

  // Parse variants data embedded in snippet (no network)
  let variantsMap = null;
  try{
    const variantsScript = sticky.querySelector('[data-dt-sticky-variants]');
    if(variantsScript){
      const arr = JSON.parse(variantsScript.textContent || '[]');
      variantsMap = new Map(arr.map(v => [String(v.id), v]));
    }
  }catch(e){
    variantsMap = null;
  }

  const idInput = productForm.querySelector('input[name="id"], select[name="id"]');

  let submitInView = true;
  let footerInView = false;
  let scrollingDown = true;
  let lastScrollY = window.scrollY || 0;
  let lastVariantId = null;

  const toggle = () => {
    const shouldShow = !submitInView && !footerInView && scrollingDown;
    sticky.classList.toggle('is-visible', !!shouldShow);
  };

  // Observe visibility of real submit button
  const io = new IntersectionObserver((entries)=>{
    for(const e of entries){
      submitInView = e.isIntersecting;
    }
    toggle();
  }, { threshold: 0.15 });
  io.observe(submitBtn);

  // Observe footer (hide when footer appears)
  const footer = document.querySelector('footer, .site-footer, .footer');
  if(footer){
    const footerIO = new IntersectionObserver((entries)=>{
      for(const e of entries){
        footerInView = e.isIntersecting;
      }
      toggle();
    }, { threshold: 0.01 });
    footerIO.observe(footer);
  }

  const syncBtnState = () => {
    const disabled = submitBtn.hasAttribute('disabled') || submitBtn.disabled;
    stickyBtn.disabled = !!disabled;
  };

  const setSaleUI = (isOnSale) => {
    if(stickyCompare) stickyCompare.hidden = !isOnSale;
    if(stickySaleLabel) stickySaleLabel.hidden = !isOnSale;
    if(stickyDiscount) stickyDiscount.hidden = !isOnSale;
  };

  const updateFromVariant = () => {
    if(!idInput || !variantsMap) return false;
    const vid = String(idInput.value || '');
    if(!vid) return false;

    const v = variantsMap.get(vid);
    if(!v) return false;

    lastVariantId = vid;

    if(stickyImg){
      const src = (typeof v.image === 'string' && v.image) ? v.image : featuredImgUrl;
      if(src) stickyImg.src = src;
    }

    if(stickyPrice && v.price_formatted) stickyPrice.textContent = v.price_formatted;

    const compare = Number(v.compare_at_price || 0);
    const price = Number(v.price || 0);
    const onSale = compare > price && compare > 0 && price >= 0;

    if(stickyCompare && v.compare_formatted) stickyCompare.textContent = v.compare_formatted;

    if(stickyDiscountPct){
      if(onSale){
        const pct = Math.round(((compare - price) * 100) / compare);
        stickyDiscountPct.textContent = `${pct}%`;
      }
    }

    setSaleUI(onSale);
    return true;
  };

  // Fallback: best-effort sync price from common selectors in theme
  const syncPriceFallback = () => {
    if(!stickyPrice) return;

    const candidates = [
      document.querySelector('[data-product-price]'),
      document.querySelector('.element-text--price:not([style*="line-through"])'),
      document.querySelector('.product__price'),
      document.querySelector('.product-single__price'),
      document.querySelector('.price__current'),
      document.querySelector('[data-price] .money'),
      document.querySelector('.price .money'),
      document.querySelector('.element-text--price'),
    ].filter(Boolean);

    const node = candidates[0];
    if(node){
      const t = (node.textContent || '').trim();
      if(t) stickyPrice.textContent = t;
    }
  };

  const syncAll = () => {
    syncBtnState();
    // Prefer variant map; fallback to DOM text.
    const ok = updateFromVariant();
    if(!ok) syncPriceFallback();
  };

  // Observe submit button changes
  const mo = new MutationObserver(syncAll);
  mo.observe(submitBtn, { attributes: true, childList: true, subtree: true });

  // Update on form interactions
  productForm.addEventListener('change', ()=>{ syncAll(); }, true);
  productForm.addEventListener('input', ()=>{ syncAll(); }, true);
  document.addEventListener('variant:change', ()=>{ syncAll(); }, true);
  document.addEventListener('variantChange', ()=>{ syncAll(); }, true);

  // Light polling for themes that update variant id programmatically without events
  const poll = window.setInterval(()=>{
    if(!idInput || !variantsMap) return;
    const vid = String(idInput.value || '');
    if(vid && vid !== lastVariantId){
      syncAll();
    }
  }, 350);

  // Hide on scroll up
  const updateDirection = () => {
    const y = window.scrollY || 0;
    const diff = y - lastScrollY;
    if(Math.abs(diff) > 8){
      scrollingDown = diff > 0;
      lastScrollY = y;
      toggle();
    }
  };
  window.addEventListener('scroll', updateDirection, { passive: true });

  // Click -> trigger real form submit (keeps theme logic)
  stickyBtn.addEventListener('click', ()=>{
    if(stickyBtn.disabled) return;
    if(typeof productForm.requestSubmit === 'function'){
      productForm.requestSubmit(submitBtn);
    }else{
      submitBtn.click();
    }
  });

  // Initial sync
  syncAll();

  // Cleanup if needed (page changes via PJAX; just in case)
  window.addEventListener('beforeunload', ()=>{ try{ window.clearInterval(poll); }catch(e){} });

})();
